import { ErrorMessage } from "@hookform/error-message";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { getSPToken, ISingpassTokenResponse } from "../../api/apimethods";
import Loader from "../../components/molecules/Loader";
import {
  useApiService,
  apexApiService,
  useContextService,
} from "../../services";
import { notify } from "../../utils";
import { NotifyType, PageUrl, SessionKey } from "../../utils/app-config";
import { ILocalUser } from "../../typings/models/LocalUser";
import Contaier from "../../components/layout/Container/Container";
import Footer from "../../components/molecules/Footer/Footer";
import LoginHeader from "../../components/molecules/Header/LoginHeader";
import logocp from "../../assets/corppass-login-icon.svg";
import logosp from "../../assets/singpass-login-icon.svg";

function Login() {
  const navigate = useNavigate();
  const { ForeignerLoginUser } = apexApiService();
  const { loginUser } = useApiService();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ILocalUser>();
  const { putContextUser } = useContextService();
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [authToken, setAuthToken] = useState(false);
  const [loading, setLoading] = useState(false);
  const [singpassAuth, setSingpassAuth] = useState<ISingpassTokenResponse | null>(null);
  const { message } = notify();
  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
    };

  useEffect(() => {
    const localauthToken = localStorage?.getItem(SessionKey.AuthToken) ?? '';
    if (localauthToken) {
      setAuthToken(true)
    }
  }, [authToken]);

  if (authToken == true) {
    navigate(PageUrl.Home);
  }

  const onClickLogin = async () => {
    handleSubmit(async (userModel: ILocalUser) => {
      setLoading(true);
      /*SIT or Local - from local eservices api - please enable below line of code*/
      //let tokenResponse = await loginUser(userModel);
      /*UAT - From apex api*/
      const tokenResponse = await ForeignerLoginUser(userModel);
      setLoading(false);
      if (tokenResponse && tokenResponse.isValidUser && tokenResponse.user) {
        await putContextUser(tokenResponse.user);
        localStorage.setItem(SessionKey.AuthToken, tokenResponse.jwt);
        if (tokenResponse.forcePassword === true) {
          navigate(PageUrl.ForceChangePassword);
        } else {
          window.location.href = "/eservices/";
        }
      } else {
        message(
          NotifyType.Error,
          "User Authentication failed. Please try again."
        );
      }
    })();
  };

  const onClickSingpass = async () => {
    try {
      const response = await getSPToken("authrequest", "auth");
      const authData = response?.data ?? response;

      if (!authData || typeof authData !== "object") {
        message(NotifyType.Error, "Failed to start Singpass login.");
        return;
      }

      const singpassData: ISingpassTokenResponse = {
        redirectUri: authData.redirectUri,
        cacheId : authData.cacheId
      };

      setSingpassAuth(singpassData);
      localStorage.setItem("singpassAuth", JSON.stringify(singpassData));

      if (!singpassData.redirectUri) {
        message(NotifyType.Error, "Failed to start Singpass login.");
        return;
      }

      window.location.href = singpassData.redirectUri;
    } catch (error) {
      message(NotifyType.Error, "Singpass login failed. Please try again.");
    }
  };

  return (
    <>
      <LoginHeader />
      <Contaier>
        <div className="inner-bx">
          <div className="container">
            <div className="row py-5">
              <div className="col-lg-6">
                <div className="row  justify-content-center m-0 mb-3 mb-lg-0">
                  <div className="col-sm-10 col-md-6 col-lg-12 login-singpass-content mb-5 text-center text-lg-start">
                    <h1 className="mb-2 text-center text-lg-start">Singpass</h1>
                    <p className="text-center text-lg-start">
                      To local entities / individuals without registered UEN
                    </p>
                    <button
                      type="button"
                      className="btn btn-singpass"
                      onClick={onClickSingpass}
                    >
                      Login with <img src={logosp} alt="Singpass" />
                    </button>
                  </div>
                  <div className="w-100"></div>
                  <div className="col-sm-10 col-md-6 col-lg-12 login-singpass-content mb-5 text-center text-lg-start">
                    <h1 className="mb-2 text-center text-lg-start">Corppass</h1>
                    <p className="text-center text-lg-start">
                      For corporate users who have registered for corppass to
                      access and transact on behalf of their organization
                    </p>
                    <a
                      href="/eservices/cp-login?ut=Company&lt=CorpPass"
                      className="btn btn-corppass"
                    >
                      {" "}
                      Login with <img src={logocp} />
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="row m-0 justify-content-center justify-content-lg-end">
                  <div className="col-sm-10 col-md-6 col-lg-9">
                    <div className="login-wrapper">
                      <h1>Login</h1>
                      <p className="">
                        Login for foreigners using NParks provided account
                      </p>
                      <div className="">
                        <div className="mb-3">
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Email Address"
                              id="UserId"
                              {...register("UserId", {
                                required: "Please enter email address",
                              })}
                            />
                            <span
                              className="input-group-text"
                              id="basic-addon2"
                            >
                              <i className="fa fa-user" aria-hidden="true"></i>
                            </span>
                          </div>
                          <div className="input-group">
                            <ErrorMessage
                              errors={errors}
                              name="UserId"
                              render={({ message }) => (
                                <p className="errorMsg mb-0">{message}</p>
                              )}
                            />
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="input-group">
                            <input
                              type={isPasswordVisible ? "text" : "password"}
                              className="form-control"
                              placeholder="Password"
                              id="Password"
                              {...register("Password", {
                                required: "Please enter Password",
                              })}
                            />
                            <span
                              className="input-group-text"
                              id="basic-addon2"
                              onClick={togglePasswordVisibility}
                            >
                              <i className="fa fa-eye" aria-hidden="true"></i>
                            </span>
                          </div>
                          <div className="input-group">
                            <ErrorMessage
                              errors={errors}
                              name="Password"
                              render={({ message }) => (
                                <p className="errorMsg mb-0">{message}</p>
                              )}
                            />
                          </div>
                        </div>
                        <button
                          className="btn btn-primary mb-3 w-75"
                          onClick={onClickLogin}
                          type="button"
                        >
                          {loading ? <Loader /> : <>Login</>}
                        </button>
                      </div>
                      <div className="row">
                        <div className="col-xl-6 text-xl-start">
                          <a href="/eservices/forget-password" className="">
                            Forget Password?
                          </a>
                        </div>
                        <div className="col-xl-6 text-xl-end">
                          {" "}
                          <a
                            href="/eservices/account-registration"
                            className=""
                          >
                            Register New Account
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Contaier>
      <Footer />
    </>
  );
}

export default Login;
